import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import type { CustomCellEditorProps } from "ag-grid-react";
import CIQDatePicker from "components/custom-date-picker";
import { DATE_FORMAT_MMDDYYYY, DateUtils } from "utils/dateutils";
import { Button } from "antd";

export default function CustomDateCellEditor({
  value,
  onValueChange,
  eventKey,
  placeholder,
  stopEditing
}: CustomCellEditorProps & { placeholder?: string }) {
  const pickerRef = useRef<any>(null);

  const [open, setOpen] = useState(false);

  /** Convert incoming AG Grid string → moment */
  const initialMoment = value ? DateUtils.dateTimeObj(value) : null;

  /** On mount: decide initial value + focus + open popup */
  useEffect(() => {
    // Handle keyboard edit start (Backspace, typing, etc.)
    if (eventKey === "Backspace") {
      onValueChange(null);
    } else {
      onValueChange(initialMoment);
    }

    // Focus + open panel
    setTimeout(() => {
      pickerRef.current?.focus?.();
      pickerRef.current?.open?.(); // supported by your wrapper
      setOpen(true);
    }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // IMPORTANT: run only once

  /** When user selects a date */
  const handleChange = (newVal: any) => {
    const iso = newVal ? moment(newVal).toISOString() : null;

    onValueChange(iso);

    // Close editor immediately after selection
    stopEditing();
  };

  return (
    <div className="h-full flex items-center">
      <CIQDatePicker
        ref={pickerRef}
        className="w-full h-8 border-0"
        format={DATE_FORMAT_MMDDYYYY}
        placeholder={placeholder}
        value={initialMoment}
        onChange={handleChange}
        open={open}
        onOpenChange={(o) => setOpen(o)}
        allowClear={false}
        inputReadOnly
        renderExtraFooter={() =>
          initialMoment ? (
            <div className="flex justify-center py-2 w-full">
              <Button
                onClick={() => {
                  handleChange(null);
                }}
                data-testid="index-button-clear-date"
              >
                Clear Date
              </Button>
            </div>
          ) : null
        }
      />
    </div>
  );
}
